import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { class: "title-container" }
const _hoisted_4 = { class: "filter-container" }
const _hoisted_5 = { class: "dataTable" }
const _hoisted_6 = { class: "headerWrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_FilterFournisseur = _resolveComponent("FilterFournisseur")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('reglements.title')) + " ", 1),
          _createVNode(_component_ReglePastille, { cle: "reglementsFournisseur.definition" })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_FilterFournisseur, {
          onSearch: _ctx.search,
          onClearFilter: _ctx.clearFilter,
          onSetFactureDateFrom: _ctx.setFactureDateFrom,
          onSetFactureDateTo: _ctx.setFactureDateTo,
          onComparison: _ctx.setComparison,
          onComparisonValue: _ctx.setComparisonValue,
          onAddFilterSociete: _ctx.addSociete,
          onRemoveFilterSociete: _ctx.removeSociete,
          onMultipleSelectSearchSociete: _ctx.multipleSelectSearchSociete,
          onSocieteToggleSelectAll: _ctx.societeToggleSelectAll,
          "comparison-list-facture": _ctx.comparisonListFacture,
          filter: _ctx.filter,
          "societe-list": _ctx.societeList,
          "societe-list-total": _ctx.societeListTotal
        }, null, 8, ["onSearch", "onClearFilter", "onSetFactureDateFrom", "onSetFactureDateTo", "onComparison", "onComparisonValue", "onAddFilterSociete", "onRemoveFilterSociete", "onMultipleSelectSearchSociete", "onSocieteToggleSelectAll", "comparison-list-facture", "filter", "societe-list", "societe-list-total"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.count) + " " + _toDisplayString(_ctx.$t('reglement.fournisseur.dataTable.title', _ctx.count > 1 ? 2 : 1)), 1),
          (_ctx.tableData.length > 0)
            ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                key: 0,
                class: "export-button",
                onClick: _ctx.exportXls,
                imgUrl: _ctx.iconeXls,
                title: _ctx.$t('factures.export')
              }, null, 8, ["onClick", "imgUrl", "title"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.tableData.length === 0 && _ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_LoaderComponent, {
              key: 0,
              class: "loader"
            }))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
              ref: "content",
              class: "datatable-container"
            }, [
              _createVNode(_component_DataTable, {
                count: +_ctx.count,
                tableData: _ctx.tableData,
                tableHeader: _ctx.tableHeader,
                isLoading: _ctx.isLoading,
                "stop-propa-on-pdf": true,
                onSort: _ctx.doSort,
                onSelect: _ctx.goToPage
              }, null, 8, ["count", "tableData", "tableHeader", "isLoading", "onSort", "onSelect"])
            ], 544))
      ]),
      (_ctx.isExportXlsLoading)
        ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ]))
}